export { default } from './NamedIcon';
